"use strict";

import { commonConstants } from "../../_redux/_constants";

export function ajaxError(error) {
    return {
        type: commonConstants.AJAX_ERROR,
        payload: error,
    };
}

export function refreshTokenError(error) {
    return {
        type: commonConstants.REFRESH_TOKEN_ERROR,
        payload: error,
    };
}

export function ajaxSuccess(message) {
    return {
        type: commonConstants.AJAX_SUCCESS,
        payload: message,
    };
}

export function hideAjaxSuccess() {
    return {
        type: commonConstants.HIDE_AJAX_SUCCESS,
    };
}

export function hideSuccessMessage() {
    return {
        type: commonConstants.HIDE_SUCCESS_SERVER_MESSAGE,
    };
}

export function hideCustomeError(code) {
    return {
        type: commonConstants.HIDE_ERROR_CUSTOM_SERVER_MESSAGE,
        payload: code,
    };
}

export function hideConfirmServerError() {
    return {
        type: commonConstants.HIDE_ERROR_CONFIRM_SERVER_MESSAGE,
    };
}

export function hideError(code) {
    return {
        type: commonConstants.HIDE_ERROR_SERVER_MESSAGE,
    };
}
